<div class="dt-main">
  <app-sidebar></app-sidebar>

  <div class="dt-content-wrapper overflow-y-scroll">
    <div class="dt-content">
      <div class="col-md-12 spc-padding midbxCol">
        <h2 class="pageHeading">
          <span class="main-chevron">
            <a routerLink="/alertreports">
              <svg
                width="10"
                height="15"
                viewBox="0 0 10 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.666748 7.5L7.91675 14.75L9.6205 13.0463L4.08633 7.5L9.6205 1.95375L7.91675 0.250003L0.666748 7.5Z"
                  fill="#0D1758"
                ></path>
              </svg>
            </a>
          </span>
          Connectivity
        </h2>

        <div class="card bggrey tabs-container live-usage-table-list-cont">
          <svg
            width="1032"
            height="48"
            viewBox="0 0 1032 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="1032"
              height="48"
              rx="6"
              fill="white"
            />
            <g clip-path="url(#clip0_7201_18564)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M25.0996 14.9996C25.0996 13.9526 25.9526 13.0996 26.9996 13.0996H32.9996C34.0467 13.0996 34.8996 13.9526 34.8996 14.9996V22.9996C34.8996 24.0467 34.0467 24.8996 32.9996 24.8996H26.9996C25.9526 24.8996 25.0996 24.0467 25.0996 22.9996V14.9996ZM26.9298 14.9298C26.9089 14.9506 26.8996 14.9749 26.8996 14.9996V22.9996C26.8996 23.0243 26.9089 23.0486 26.9298 23.0695C26.9506 23.0903 26.9749 23.0996 26.9996 23.0996H32.9996C33.0243 23.0996 33.0486 23.0903 33.0695 23.0695C33.0903 23.0486 33.0996 23.0243 33.0996 22.9996V14.9996C33.0996 14.9749 33.0903 14.9506 33.0695 14.9298C33.0486 14.9089 33.0243 14.8996 32.9996 14.8996H26.9996C26.9749 14.8996 26.9506 14.9089 26.9298 14.9298ZM37.0996 14.9996C37.0996 13.9526 37.9526 13.0996 38.9996 13.0996H44.9996C46.0467 13.0996 46.8996 13.9526 46.8996 14.9996V18.9996C46.8996 20.0467 46.0467 20.8996 44.9996 20.8996H38.9996C37.9526 20.8996 37.0996 20.0467 37.0996 18.9996V14.9996ZM38.9298 14.9298C38.9089 14.9506 38.8996 14.9749 38.8996 14.9996V18.9996C38.8996 19.0243 38.9089 19.0486 38.9298 19.0695C38.9506 19.0903 38.9749 19.0996 38.9996 19.0996H44.9996C45.0243 19.0996 45.0486 19.0903 45.0695 19.0695C45.0903 19.0486 45.0996 19.0243 45.0996 18.9996V14.9996C45.0996 14.9749 45.0903 14.9506 45.0695 14.9298C45.0486 14.9089 45.0243 14.8996 44.9996 14.8996H38.9996C38.9749 14.8996 38.9506 14.9089 38.9298 14.9298ZM37.0996 24.9996C37.0996 23.9526 37.9526 23.0996 38.9996 23.0996H44.9996C46.0467 23.0996 46.8996 23.9526 46.8996 24.9996V32.9996C46.8996 34.0467 46.0467 34.8996 44.9996 34.8996H38.9996C37.9526 34.8996 37.0996 34.0467 37.0996 32.9996V24.9996ZM38.9298 24.9298C38.9089 24.9506 38.8996 24.9749 38.8996 24.9996V32.9996C38.8996 33.0243 38.9089 33.0486 38.9298 33.0695C38.9506 33.0903 38.9749 33.0996 38.9996 33.0996H44.9996C45.0243 33.0996 45.0486 33.0903 45.0695 33.0695C45.0903 33.0486 45.0996 33.0243 45.0996 32.9996V24.9996C45.0996 24.9749 45.0903 24.9506 45.0695 24.9298C45.0486 24.9089 45.0243 24.8996 44.9996 24.8996H38.9996C38.9749 24.8996 38.9506 24.9089 38.9298 24.9298ZM25.0996 28.9996C25.0996 27.9526 25.9526 27.0996 26.9996 27.0996H32.9996C34.0467 27.0996 34.8996 27.9526 34.8996 28.9996V32.9996C34.8996 34.0467 34.0467 34.8996 32.9996 34.8996H26.9996C25.9526 34.8996 25.0996 34.0467 25.0996 32.9996V28.9996ZM26.9298 28.9298C26.9089 28.9506 26.8996 28.9749 26.8996 28.9996V32.9996C26.8996 33.0243 26.9089 33.0486 26.9298 33.0695C26.9506 33.0903 26.9749 33.0996 26.9996 33.0996H32.9996C33.0243 33.0996 33.0486 33.0903 33.0695 33.0695C33.0903 33.0486 33.0996 33.0243 33.0996 32.9996V28.9996C33.0996 28.9749 33.0903 28.9506 33.0695 28.9298C33.0486 28.9089 33.0243 28.8996 32.9996 28.8996H26.9996C26.9749 28.8996 26.9506 28.9089 26.9298 28.9298Z"
                fill="#6285FB"
              />
            </g>

            <!-- <path
              d="M80.0001 35C81.3189 35 82.4545 34.2034 82.9528 33.0664H77.0473C77.5456 34.2034 78.6813 35 80.0001 35ZM86.6602 23.6503V22.2383C86.6602 19.2381 84.666 16.6953 81.9337 15.8647V14.9336C81.9337 13.8674 81.0663 13 80.0001 13C78.9339 13 78.0665 13.8674 78.0665 14.9336V15.8647C75.3341 16.6953 73.3399 19.2381 73.3399 22.2383V23.6503C73.3399 26.2857 72.3354 28.7846 70.5114 30.6867C70.424 30.7779 70.3652 30.8927 70.3425 31.017C70.3198 31.1413 70.3341 31.2695 70.3837 31.3857C70.4333 31.5019 70.5159 31.601 70.6213 31.6706C70.7267 31.7403 70.8503 31.7774 70.9766 31.7773H89.0235C89.1498 31.7773 89.2734 31.7402 89.3788 31.6706C89.4842 31.601 89.5668 31.5019 89.6164 31.3857C89.6659 31.2695 89.6803 31.1413 89.6576 31.017C89.6349 30.8928 89.5762 30.7779 89.4887 30.6867C87.6648 28.7846 86.6602 26.2856 86.6602 23.6503ZM80.6446 15.6094C80.4325 15.589 80.2175 15.5781 80.0001 15.5781C79.7827 15.5781 79.5677 15.589 79.3555 15.6094V14.9336C79.3555 14.5782 79.6447 14.2891 80.0001 14.2891C80.3555 14.2891 80.6446 14.5782 80.6446 14.9336V15.6094ZM88.379 22.2383C88.379 22.5942 88.6676 22.8828 89.0235 22.8828C89.3795 22.8828 89.668 22.5942 89.668 22.2383C89.668 19.6559 88.6624 17.228 86.8364 15.402C86.5847 15.1503 86.1766 15.1502 85.9249 15.402C85.6732 15.6537 85.6732 16.0617 85.9249 16.3134C87.5074 17.896 88.379 20.0002 88.379 22.2383ZM70.9766 22.8828C71.3326 22.8828 71.6212 22.5942 71.6212 22.2383C71.6212 20.0002 72.4927 17.8961 74.0753 16.3135C74.327 16.0618 74.327 15.6537 74.0753 15.402C73.8236 15.1503 73.4155 15.1503 73.1638 15.402C71.3377 17.228 70.3321 19.6559 70.3321 22.2383C70.3321 22.5942 70.6207 22.8828 70.9766 22.8828Z"
              fill="#AFB6CE"
            /> -->

            <defs>
              <clipPath id="clip0_7201_18564">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(24 12)"
                />
              </clipPath>
            </defs>
          </svg>

          <div style="margin-left: 0.2%; margin-top: 1%; margin-bottom: 1%">
            Connectivity Status
          </div>

          <div class="panelScroll panelTableContainer">
            <div class="panelHeading headerClass">
              <div>Panels</div>
              <div>Current Status</div>
              <div>Connection Type</div>
              <div>Network Name</div>
              <div>Network Strength</div>
            </div>

            <div
              *ngFor="let panel of panels; let i = index"
              class="panelRow panelHeading"
            >
              <div class="panelRunning">
                <div class="greybx">
                  <span
                    [ngClass]="panel.panelIsconnected ? 'green' : 'red'"
                  ></span>
                </div>

                <div class="heading">{{ panel.panel_name }}</div>

                <svg
                  fill="#ccc"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="18px"
                  height="18px"
                  (click)="openConnectivityDialog(panel)"
                  style="cursor: pointer"
                  *ngIf="panel.meter_id"
                >
                  <path
                    d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                  ></path>
                </svg>
              </div>

              <div>
                <div
                  *ngIf="panel.panelIsconnected == true"
                  class="connectivity-message"
                  [ngStyle]="{ 'background-color': 'green' }"
                >
                  <span>Online</span>
                </div>

                <div
                  *ngIf="panel.panelIsconnected == false"
                  class="connectivity-message"
                  [ngStyle]="{ 'background-color': 'red' }"
                >
                  Offline
                </div>

                <div
                  *ngIf="panel.panelIsconnected == null"
                  class="connectivity-message"
                  [ngStyle]="{ 'background-color': '#ff7f27' }"
                >
                  Disconnected
                </div>
              </div>

              <div style="display: flex; align-items: center">
                <svg
                  *ngIf="
                    panel.connectivity?.network_type.toLowerCase() === 'wifi'
                  "
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  [attr.fill]="panel.panelIsconnected ? '#6285FB' : '#666F82'"
                  [style.color]="panel.panelIsconnected ? '#6285FB' : '#666F82'"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0475 15.5256C11.3379 15.5256 12.384 14.4795 12.384 13.1891C12.384 11.8986 11.3379 10.8525 10.0475 10.8525C8.75703 10.8525 7.71094 11.8986 7.71094 13.1891C7.71094 14.4795 8.75703 15.5256 10.0475 15.5256Z"
                    fill="currentcolor"
                  />
                  <path
                    d="M15.6314 7.55996C15.5967 7.52432 15.5601 7.49254 15.5245 7.45979L15.4195 7.36059C15.4021 7.34229 15.3829 7.32881 15.3607 7.31147C13.9111 5.98999 12.0078 5.27827 10.0467 5.32437C8.0857 5.37048 6.21793 6.17085 4.83198 7.55899L4.49393 7.89801L4.02586 8.36608C3.75218 8.6414 3.59889 9.01403 3.59961 9.40222C3.60033 9.79042 3.75501 10.1625 4.02971 10.4368C4.1654 10.573 4.32661 10.6812 4.50412 10.7551C4.68163 10.8291 4.87197 10.8673 5.06426 10.8677C5.25655 10.868 5.44703 10.8305 5.62481 10.7572C5.8026 10.6839 5.9642 10.5764 6.1004 10.4406L6.90749 9.63354C7.79013 8.75357 8.9856 8.25935 10.232 8.25917C11.4783 8.25899 12.6739 8.75286 13.5568 9.63257L14.1395 10.197C14.4124 10.4682 14.7819 10.6201 15.1667 10.6192C15.5515 10.6183 15.9202 10.4647 16.1919 10.1921C16.3273 10.0577 16.4347 9.89771 16.5079 9.72149C16.5812 9.54527 16.6188 9.35629 16.6186 9.16546C16.6198 8.97526 16.583 8.78672 16.5104 8.61091C16.4378 8.43511 16.3308 8.27557 16.1957 8.14168L15.6314 7.55996Z"
                    fill="currentcolor"
                  />
                  <path
                    d="M19.6121 4.67155L19.1267 4.18614C19.1248 4.18421 19.1238 4.18132 19.1199 4.18036L18.7366 3.79511C18.6701 3.72982 18.5972 3.67141 18.519 3.62079C13.5946 -0.702623 6.10444 -0.569714 1.33703 4.01663C1.31392 4.03782 1.28791 4.05226 1.2648 4.07538L0.388364 4.95278C0.264717 5.07696 0.166772 5.22431 0.100133 5.38639C0.0334941 5.54847 -0.000530481 5.7221 6.25248e-06 5.89734C0.000542986 6.07259 0.0356305 6.246 0.103261 6.40767C0.170892 6.56934 0.269738 6.71609 0.394143 6.83951C0.517632 6.96386 0.664428 7.06263 0.826131 7.13017C0.987834 7.19772 1.16127 7.23272 1.33651 7.23317C1.51176 7.23361 1.68537 7.1995 1.84741 7.13278C2.00946 7.06606 2.15676 6.96804 2.28088 6.84433L3.15731 5.96886C3.16309 5.96115 3.16791 5.95441 3.17369 5.9496C7.02903 2.22524 13.1448 2.20213 17.031 5.87351L17.7205 6.56406C17.9716 6.8135 18.3115 6.95309 18.6654 6.95219C19.0193 6.95128 19.3584 6.80996 19.6082 6.55925C19.8586 6.30917 19.9996 5.97004 20.0003 5.61619C20.001 5.26234 19.8614 4.92264 19.6121 4.67155Z"
                    fill="currentcolor"
                  />
                </svg>

                <svg
                  *ngIf="
                    panel.connectivity?.network_type.toLowerCase() ===
                    'ethernet'
                  "
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  [attr.fill]="panel.panelIsconnected ? '#6285FB' : '#666666'"
                  [style.color]="panel.panelIsconnected ? '#6285FB' : '#666F82'"
                  xmlns="http://www.w3.org/2000/svg"
                  ]
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.0248 2.15109H3.97516C2.53441 2.15109 1.36646 3.27769 1.36646 4.66743V15.3319C1.36646 16.7217 2.53441 17.8483 3.97516 17.8483H16.0248C17.4656 17.8483 18.6335 16.7217 18.6335 15.3319V4.66743C18.6335 3.27769 17.4656 2.15109 16.0248 2.15109ZM3.97516 0.833008C1.77974 0.833008 0 2.54974 0 4.66743V15.3319C0 17.4496 1.77974 19.1663 3.97516 19.1663H16.0248C18.2203 19.1663 20 17.4496 20 15.3319V4.66743C20 2.54974 18.2203 0.833008 16.0248 0.833008H3.97516Z"
                    fill="currentcolor"
                  />
                  <path
                    d="M3.22981 11.7971H4.96894V13.4746C4.96894 13.7393 5.19141 13.9539 5.46584 13.9539H7.01863V15.272C7.01863 15.5367 7.2411 15.7513 7.51553 15.7513H12.4845C12.7589 15.7513 12.9814 15.5367 12.9814 15.272V13.9539H14.5342C14.8086 13.9539 15.0311 13.7393 15.0311 13.4746V11.7971H16.7702C17.0446 11.7971 17.2671 11.5825 17.2671 11.3178V5.20665C17.2671 4.28016 16.4884 3.52909 15.528 3.52909H4.34783C3.45594 3.52909 2.73292 4.22651 2.73292 5.08682V11.3178C2.73292 11.5825 2.95539 11.7971 3.22981 11.7971Z"
                    fill="currentcolor"
                  />
                </svg>

                <span style="text-transform: capitalize; margin-left: 6px">{{
                  panel.connectivity?.network_type
                }}</span>
              </div>

              <div>{{ panel.connectivity?.network_params.ssid ?? '' }}</div>

              <div *ngIf="panel.connectivity?.network_params.rssi">
                <span>{{
                  getRssiMeta(panel.connectivity.network_params.rssi).value
                }}</span>
                <span
                  style="font-weight: bold; margin-left: 6px"
                  [style.color]="
                    getRssiMeta(panel.connectivity.network_params.rssi).fill
                  "
                  >{{
                    getRssiMeta(panel.connectivity.network_params.rssi).text
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
